export default "__VITE_ASSET__f7286fd5__"